import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Pagination from 'rc-pagination';
import USLocale from 'rc-pagination/lib/locale/en_US';
import 'rc-pagination/assets/index.css';

import formatClassDateRange from './formatClassDateRange';
import Icon from '../common/icons/Icon';

class ClassList extends Component {
  static propTypes = {
    school: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
  };

  render() {
    const { school, classes, page, search, setPage } = this.props;
    return (
      <div>
        <ul className="admin-paper__list" key="course-chapters">
          {classes.results.length ? (
            classes.results.map((item, index) => (
              <li key={index}>
                <div className="admin-paper__list__title">{formatClassDateRange(item.start_date, school.days)}</div>
                <div className="admin-paper__list__actions">
                  <Link
                    className="admin-paper__list__link"
                    to={`/golf-schools/${school.id}/classes/${item.id}${search}`}
                  >
                    Go to Class <Icon icon="Arrow" />
                  </Link>
                </div>
              </li>
            ))
          ) : (
            <div className="admin-paper__no-content">There are currently no classes</div>
          )}
        </ul>
        <div className="admin-pagination__wrapper">
          {classes.pagination.rowCount > classes.pagination.pageSize ? (
            <Pagination
              onChange={setPage}
              current={parseInt(page, 10)}
              pageSize={classes.pagination.pageSize}
              total={classes.pagination.rowCount}
              locale={USLocale}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

export default ClassList;



// WEBPACK FOOTER //
// ./src/golf-schools/ClassList.js